import { Injectable } from '@angular/core';
import { UseService } from '@df/util/service/use.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
    providedIn: 'root'
})
export class BottomPanelService {
    constructor(private useService: UseService) {}

    private toGlobalId(id: string): string {
        return ['bottomPanel', id].join();
    }

    onShow(id: string, source: unknown): void {
        this.useService.lock(this.toGlobalId(id), source);
    }

    onHide(id: string, source: unknown): void {
        this.useService.unlock(this.toGlobalId(id), source);
    }

    observe(id: string): BehaviorSubject<boolean> {
        return this.useService.getState(this.toGlobalId(id)).obs;
    }
}
